/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { Text } from '@taxdown/piccolo-web';
import Trans from 'Components/Trans';
import { openLinkInNewTab } from 'Utils/links';
import { URL_PRIVACY_POLICY, URL_TERMS_OF_SERVICE } from 'Config';
import * as Styled from './styles';

const TermsAndConditions = (): JSX.Element => {
  return (
    <Styled.Terms>
      <Text type="paragraphs" size="XS_S_S" color="dark">
        <Trans
          i18nKey="Terms.text"
          components={{
            privacy: (
              <Styled.ButtonStyledLink
                type="button"
                onClick={() => openLinkInNewTab(URL_PRIVACY_POLICY)}
              />
            ),
            terms: (
              <Styled.ButtonStyledLink
                type="button"
                onClick={() => openLinkInNewTab(URL_TERMS_OF_SERVICE)}
              />
            ),
          }}
          ns="account"
        />
      </Text>
    </Styled.Terms>
  );
};

export default TermsAndConditions;
